var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiPlatformGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.75a.403.403 0 0 0-.375-.375h-9a.385.385 0 0 0-.375.375V13c0 .21.164.375.375.375h9a.385.385 0 0 0 .375-.375V7.75zm-.375-1.5c.82 0 1.5.68 1.5 1.5V13c0 .844-.68 1.5-1.5 1.5h-9A1.48 1.48 0 0 1 2 13V7.75c0-.82.656-1.5 1.5-1.5h9zm-.188-1.875a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H3.688a.542.542 0 0 1-.563-.563c0-.304.234-.562.563-.562h8.624zM11.188 2.5a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H4.814a.542.542 0 0 1-.563-.563c0-.304.234-.562.563-.562h6.375z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPlatformGrey);
export default __webpack_public_path__ + "static/media/multi_platform_grey.cd2f7d663a79299976a5bf74089a4286.svg";
export { ForwardRef as ReactComponent };